import React, { useMemo } from 'react'

export const PageTitleContext = React.createContext<{
  prefix?: string;
  separator?: string;
  suffix?: string;
}>({
  prefix: undefined,
  separator: ' | ',
  suffix: 'Thatch',
})

export function PageTitleProvider ({
  children,
  separator = ' | ',
  prefix,
  suffix = 'Thatch',
}: {
  children: React.ReactNode;
  prefix?: string;
  suffix?: string;
  separator?: string;
}) {
  const value = useMemo(() => ({ prefix, separator, suffix }), [prefix, separator, suffix])

  return (
    <PageTitleContext.Provider value={value}>
      {children}
    </PageTitleContext.Provider>
  )
}
